import ThePresentation from './ThePresentation';

export default ThePresentation;
